import productService from '../../products';
import tacHelpers from '../../../state/tac/tacHelpers';
import { translate } from '../../L10n';
import { t } from '../../../translations';
import { hasRoomSlots } from '../common';
import { ITEMS } from '../../../constants';

function getDisabledStatus(tac, product, space, rebased) {
  const hasOpenConnectionSlot = tacHelpers.hasOpenSlot(tac, product, rebased);
  if (
    productService.isType(product, ITEMS.FRAME) ||
    productService.isType(product, ITEMS.SHELVING_UNIT)
  ) {
    if (!hasRoomSlots(tac, space, product) && !hasOpenConnectionSlot) {
      return translate(t.BALLOON_HINT_NO_PLACE);
    }
  } else {
    if (!hasOpenConnectionSlot) {
      return translate(t.BALLOON_HINT_NO_PLACE);
    }
  }
  return false;
}

function shouldDisplayProductType(product) {
  return !productService.isType(product, [ITEMS.FRAME, ITEMS.SHELVING_UNIT]);
}

export { getDisabledStatus };

export default {
  getDisabledStatus,
  shouldDisplayProductType,
};
